// @flow
import client from '../../client'

// API Endpoinds
export const GET_PROVIDERS_ENDPOINT = '/data-entry/providers/'

/**
 * Returns all providers
 * @param {Object} data Query data
 * @param {string} data.search Search query
 * @return {Promise|Error} A resolved Promise with providers or Rejected with an Error
 */
export const search = (data: { search: string }): Promise<any> =>
  client.get(GET_PROVIDERS_ENDPOINT, { query: data })

export default search
